import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { Button, Container } from "shards-react";

const Errors = () => {
  const [redirect, setredirect] = useState(false);
  if (redirect) return <Redirect to="/" />;
  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <div className="error">
        <div className="error__content">
          <h2>401</h2>
          <h3>Parece que no estás autorizado.</h3>
          <p>Porfavor regístrate y comprueba tus permisos.</p>
          <Button pill onClick={() => setredirect(true)}>
            &larr; Página Principal
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default Errors;
